<template>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-10 px-4">
      <div id="basic-info" class="card mt-4">
        <div class="card-body pt-0 invoice-card">
          <div class="row mb-3 p-3">
            <h5>Mikrotik Information</h5>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label d-flex">Mikrotik IP <span class="d-flex align-items-center mx-3" style="gap: 5px;">
                <input type="checkbox" v-model="formData.routerv7" id="routerv7-checkbox" />
                <label for="routerv7-checkbox" class="form-label mb-0">V7+</label>
              </span></label>
               <div :class="{'has-error': formData.Mikrotik_ip && isValidMPort == false, 'has-success': formData.Mikrotik_ip && isValidMPort == true}">
                <input
                  v-model="formData.Mikrotik_ip"
                  type="text"
                  placeholder="Mikrotik IP"
                  class="form-control invoice-card"
                />
              <span v-if="formData.Mikrotik_ip && isValidMPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.Mikrotik_ip && isValidMPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Mikrotik Username</label>
              <input
                v-model="formData.m_username"
                type="text"
                placeholder="Mikrotik Username"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Mikrotik Password</label>
              <input
                v-model="formData.m_password"
                type="text"
                placeholder="Mikrotik Password"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Mikrotik Api Port</label>
              <div :class="{'has-error': formData.m_port && isValidMPort == false, 'has-success': formData.m_port && isValidMPort == true}">
                <input
                  @change="PortCheck('microtic',formData.Mikrotik_ip, formData.m_port)"
                  v-model="formData.m_port"
                  type="text"
                  placeholder="Mikrotik Port"
                  class="form-control invoice-card"
                />
                <span v-if="formData.m_port && isValidMPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.m_port && isValidMPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            <br>
            <h5>Olt Information</h5>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Name</label>
              <input
                v-model="formData.olt_name"
                type="text"
                placeholder="OLT Name"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT IP</label>
              <div :class="{'has-error': formData.olt_ip && isValidOltPort == false, 'has-success': formData.olt_ip && isValidOltPort == true}">
              <input
                v-model="formData.olt_ip"
                type="text"
                placeholder="OLT IP"
                class="form-control invoice-card"
              />
              <span v-if="formData.olt_ip && isValidOltPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.olt_ip && isValidOltPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Username</label>
              <input
                v-model="formData.olt_username"
                type="text"
                placeholder="OLT Username"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Password</label>
              <input
                v-model="formData.olt_password"
                type="text"
                placeholder="OLT Password"
                class="form-control invoice-card"
              />
            </div>
             <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Port</label>
              <div :class="{'has-error': formData.olt_port && isValidOltPort == false, 'has-success': formData.olt_port && isValidOltPort == true}">
              <input
                v-model="formData.olt_port"
                @change="PortCheck('olt',formData.olt_ip, formData.olt_port)"
                type="text"
                placeholder="OLT Port"
                class="form-control invoice-card"
              /> 
              <span v-if="formData.olt_ip && isValidOltPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.olt_ip && isValidOltPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Telnet Port</label>
              <input
                v-model="formData.telnet_port"
               
                type="text"
                placeholder="Telnet Port"
                class="form-control invoice-card"
              /> 
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Description</label>
              <input
                v-model="formData.description"
                type="text"
                placeholder="Description"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Branch</label>
              <select 
                class="form-control invoice-card" 
                v-model="formData.Branch_olt" 
              >
                <option 
                  v-for="(data, index) in branches" 
                  :key="index" 
                  :value="data.id"
                >
                  {{ data.name }}
                </option>
              </select>
            </div>

            <br>
            <h5>Notifications</h5>

             <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Whatsapp Id</label>
              <input
                v-model="formData.wav_id"
                type="text"
                placeholder="Wav Id"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Telegram Id</label>
              <input
                v-model="formData.teleg_id"
                type="text"
                placeholder="Teleg Id"
                class="form-control invoice-card"
              />
            </div>
            <br>
            <h5>Others</h5>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Data Collection Ratio</label>
              <input
                v-model="formData.data_collcetratio"
                type="text"
                placeholder="Data Collcetratio"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Snmp Port</label>
              <input
                v-model="formData.snmp_port"
                type="text"
                placeholder="Snmp Port"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Db Alert Range</label>
              <input
                v-model="formData.db_allert_range"
                type="text"
                placeholder="Db Alert Range"
                class="form-control invoice-card"
              />
            </div>

            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Olt Modes</label>
              <select v-model="formData.olt_modes" name="" id="" class="form-control invoice-card">
                <option value="" selected disabled hidden>Select Olt Mode</option>
                <option v-for="(data,index ) in cat_data.olt_mode" :key="index" :value="data.id">{{data.olt_model}}</option>
              </select>
              
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Olt Brands</label>
              <select v-model="formData.olt_brands" name="" id="" class="form-control invoice-card">
                <option value="" selected disabled hidden>Select Olt Brand</option>
                <option v-for="(data,index ) in cat_data.olt_brand" :key="index" :value="data.id">{{data.olt_brand_name}}</option>
              </select>
            </div>
            <!-- <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Status</label>
              <select v-model="formData.show" class="form-control invoice-card" name="" id="">
                  <option value="true">Show</option>
                  <option value="false">Hide</option>
              </select>
            </div> -->
          </div>
          
          <button
            class="float-end mb-0 btn btn-success"
            color="dark"
            variant="gradient"
            size="sm"
            @click="submitForm"
            :disabled="isValidMPort == false || isValidOltPort == false"
          >
            Update Olt
          </button>
            <router-link :to="{name:'OltList'}">
          <button
            class="float-end mx-3 mb-0 btn btn-secondary"
            color="dark"
            variant="gradient"
            size="sm"
          >
            Cancel
          </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataList from "../services/data_list.service";
import updateOlt from "../services/update-olt.service";
import oltCatListData from "../services/olt-cat-list.service";
import showSwal from "../mixins/showSwal.js";
import getPortCheck from "../services/check-ports.service";
import { useUserApi } from "../services/user.service";
export default {
  data() {
    return {
      cat_data : [],
      data : [],
      branches : [],
      edit_id : this.$route.params.edit_id,
      formData: {
        Mikrotik_ip: "",
        m_username: "",
        m_password: "",
        m_port: "",
        olt_ip: "",
        olt_username: "",
        olt_password: "",
        olt_port: "",
        description: "",
        Branch_olt: "",
        show: true,
        olt_name: "",
        olt_modes: "",
        olt_brands: "",
        wav_id: "",
        teleg_id: "",
        data_collcetratio: "",
        snmp_port: "",
        db_allert_range: "",
        telnet_port: "",
        routerv7: false
      },
      isValidMPort: null,
       isValidOltPort: null
    };
  },
  mounted(){
    this.getData();
    this.getBranch();
    this.getCatData();
    let user= JSON.parse(localStorage.getItem("user_data"));
    console.log(user.id)
    this.formData.login_user=user.id
  },
  methods: {
            async getBranch() {
              try {
                const response = await useUserApi().getBranchesData();
                this.branches = response;
              } catch (error) {
                console.error("Error fetching data:", error);
              }
            },
            async getData() {
                const response = await dataList.getDataList();
                this.data = response.filter(item => item.id == this.$route.params.edit_id);
                if(this.data){
                    this.formData.Mikrotik_ip =this.data[0].Mikrotik_ip;
                    this.formData.m_username =this.data[0].m_username;
                    this.formData.m_password =this.data[0].m_password;
                    this.formData.m_port =this.data[0].m_port;
                    this.formData.olt_ip =this.data[0].olt_ip;
                    this.formData.olt_username =this.data[0].olt_username;
                    this.formData.olt_password =this.data[0].olt_password;
                    this.formData.olt_port =this.data[0].olt_port;
                    this.formData.description =this.data[0].description;
                    this.formData.Branch_olt =this.data[0].Branch_olt;
                    this.formData.olt_name =this.data[0].olt_name;
                    this.formData.olt_modes =this.data[0].olt_modes;
                    this.formData.olt_brands =this.data[0].olt_brands;
                    this.formData.telnet_port =this.data[0].telnet_port;

                    this.formData.wav_id =this.data[0].wav_id;
                    this.formData.teleg_id =this.data[0].teleg_id;
                    this.formData.data_collcetratio =this.data[0].data_collcetratio;
                    this.formData.snmp_port =this.data[0].snmp_port;
                    this.formData.db_allert_range =this.data[0].db_allert_range;
                    this.formData.routerv7 = this.data[0].routerv7 === true || this.data[0].routerv7 === 'true';
                }
            },
            async PortCheck(type,ip,port){
                const response = await getPortCheck.getPortCheck(ip,port)
                console.log(response.status);
              if(type == 'microtic'){
                if(response.status == 'open'){
                  this.isValidMPort=true
                }else if(response.status == 'closed'){
                  this.isValidMPort=false
                }else{
                  this.isValidMPort=null
                }
              }else if(type == 'olt'){
                if(response.status == 'open'){
                  this.isValidOltPort=true
                }else if(response.status == 'closed'){
                  this.isValidOltPort=false
                }else{
                  this.isValidOltPort=null
                }
              }
                
            },
            async getCatData() {
                const response = await oltCatListData.getCatListData();
                this.cat_data = response;
            },
    async submitForm() {
      console.log("Form submitted with data:", this.formData);
      try {
        await updateOlt.updateData(this.formData,this.edit_id);
        showSwal.methods.showSwal({
          type: "success",
            message: "Olt Updated Successfully!",
        });
        this.$router.push("/olt-list");
        } catch (error) {
        console.error("Error adding Olt:", error);
        showSwal.methods.showSwal({
          type: "error",
            message: "Failed to Create Olt!",
        });
        }
    },

    
  }
};
</script>
<style scoped>
.has-error .form-control {
  border: 1px solid red;
}
.has-success .form-control {
  border: 1px solid green;
}
.check-icon {
  color: green!important;
  position: absolute;
  right: 20px;
  top: 37px;
}
.cross-icon {
  color: red!important;
  position: absolute;
  right: 20px;
  top: 37px;
}
</style>

